import { Link } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { usePageMeta } from "@/lib/seo";

const SECTIONS = [
  {
    t: "1. Éditeur du site",
    p: [
      "Le présent site est édité par :",
      "ASAP Technologies – SARL\n231 rue Saint-Honoré\n75001 Paris\nSIRET : 907 820 575 00021",
      "Adresse de contact : privacy@asaptech.fr",
    ],
  },
  {
    t: "2. Directeur de la publication",
    p: [
      "Le directeur de la publication est Alexandre Paris.",
    ],
  },
  {
    t: "3. Hébergement",
    p: [
      "Le site est hébergé par :",
      "Hostinger International Ltd.\n61 Lordou Vironos Street\n6023 Larnaca\nChypre",
    ],
  },
  {
    t: "4. Propriété intellectuelle",
    p: [
      "L'ensemble des éléments accessibles sur ce site (textes, visuels, logos, marques, illustrations, contenus des articles, quiz et diagnostics) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de ses titulaires respectifs, notamment ASAP Technologies et Reqen Consulting.",
      "Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de l'éditeur.",
    ],
  },
  {
    t: "5. Données personnelles",
    p: [
      "Les traitements de données personnelles réalisés dans le cadre de ce site (formulaires de contact, demande de livre blanc, quiz, diagnostics) sont décrits dans notre politique de confidentialité.",
      "Vous y trouverez notamment les informations relatives aux finalités des traitements, aux durées de conservation et aux modalités d'exercice de vos droits.",
    ],
    link: { to: "/confidentialite", label: "Consulter la politique de confidentialité" },
  },
  {
    t: "6. Cookies et mesure d'audience",
    p: [
      "Ce site utilise un outil de mesure d'audience interne afin d'améliorer votre expérience. Aucun traceur publicitaire n'est utilisé.",
      "Vous pouvez à tout moment accepter ou refuser cette mesure d'audience, et modifier votre choix via le lien « Gérer les cookies » présent en bas de chaque page.",
    ],
  },
  {
    t: "7. Responsabilité",
    p: [
      "L'éditeur s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site, mais ne saurait garantir l'absence totale d'erreurs ou d'omissions.",
      "Le site peut contenir des liens vers des sites tiers sur le contenu desquels l'éditeur n'exerce aucun contrôle et décline toute responsabilité.",
    ],
  },
];

export default function LegalPage() {
  usePageMeta(
    "Mentions légales",
    "Mentions légales du site : éditeur, directeur de la publication et hébergeur."
  );

  return (
    <main className="bg-[#0b0f19] min-h-screen" data-testid="legal-page">
      <Nav />
      <section className="pt-32 pb-20 md:pt-40">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="font-mono2 text-[11px] tracking-[0.25em] uppercase grad-text">Informations légales</div>
            <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-slate-50">
              Mentions légales
            </h1>
            <p className="mt-3 text-xs text-slate-500 font-mono2">Dernière mise à jour : 1 juillet 2026</p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={i} delay={Math.min(i * 0.03, 0.2)}>
                <div data-testid={`legal-section-${i + 1}`}>
                  <h2 className="font-heading text-lg font-semibold text-slate-100">{s.t}</h2>
                  <div className="mt-3 space-y-3">
                    {s.p.map((para, j) => (
                      <p key={j} className="text-sm text-slate-400 leading-relaxed whitespace-pre-line">
                        {para}
                      </p>
                    ))}
                    {s.link && (
                      <Link
                        to={s.link.to}
                        className="inline-block text-sm text-teal-400 hover:text-teal-300 underline underline-offset-2"
                        data-testid={`legal-section-${i + 1}-link`}
                      >
                        {s.link.label}
                      </Link>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
